module.exports = __webpack_public_path__ + "img/27.eb73a855.png";